import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, SingleWellCultureByCycleCodeController, SingleWellCultureByCycleCodeRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, CycleOocyteQualityBetweenDateController, CycleOocyteQualityBetweenDateRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { OocyteStoreItem } from '../../../testnurse/ivf/ivfworkbench/ivfoqaedit.component';
import { EmbryoStoreItem } from '../../../testnurse/ivf/ivfworkbench/ivfgradingedit.component';




@Component({
  selector: 'embryograding',
  templateUrl: './embryograding.component.html',
  styleUrls: ['./embryograding.component.scss']
})

export class EmbryogradingPVComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public EndometriumThickness: number;
  public LeftOvaries: number;
  public RightOvaries: number;
  public MedicineName: string;
  public TestName: string;
  public TestName1: string;
  public Owner: string;
  public FormattedCode: string;
  public Protocolst: string;
  public ProtocolEd: string;
  public Protocol: string;
  public Infertility: string;
  public Gender: string;
  public Age: string;
  public CycleNo: string;
  public CycleType: string;
  public TotalOocytes: string;
  public Date: Date;
  public TransferedCount: number;
  public FrozenCount: number;
  public DiscardedCount: number;
  public TotalCout: number;

  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  ScanDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  public Doc: string;
  public DocDate: string;

  CurrentSingleWellCultureByCycleCodeController: SingleWellCultureByCycleCodeController[];
  TransferrableList: SingleWellCultureByCycleCodeController[];
  DiscardedList: SingleWellCultureByCycleCodeController[];
  CurrentSingleWellCultureByCycleCodeRequest: SingleWellCultureByCycleCodeRequest;
  TreatmentCycleCode: any;
  ActorCode: any;
  LoadSingle() {

    this.CurrentSingleWellCultureByCycleCodeRequest = new SingleWellCultureByCycleCodeRequest();
    //this.CurrentSingleWellCultureByCycleCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentSingleWellCultureByCycleCodeRequest.ConditionalOperator = 10;
    this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.CurrentSingleWellCultureByCycleCodeRequest.TreatmentCycle = this.TreatmentCycleCode;
    this.CurrentSingleWellCultureByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetSingleWellCultureByCycleCodeController()
  }
  GetSingleWellCultureByCycleCodeController() {
    this.StartRefreshing();


    this.actorservice.GetSingleWellCultureByCycleCodeController(this.CurrentSingleWellCultureByCycleCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentSingleWellCultureByCycleCodeController = this.ApiResData.Result;
          this.TotalCout = this.CurrentSingleWellCultureByCycleCodeController.length;
          this.TransferrableList = this.ApiResData.Result;
          this.DiscardedList = this.ApiResData.Result;
          var list = this.CurrentSingleWellCultureByCycleCodeController.filter(
            function (a) {
              return a.IsFrozen == true
            });
          this.CurrentSingleWellCultureByCycleCodeController = list;
          this.FrozenCount = this.CurrentSingleWellCultureByCycleCodeController.length;
          var listTransferrable = this.TransferrableList.filter(
            function (b) {
              return b.IsTransferrable == true;
            });
          this.TransferrableList = listTransferrable;
          this.TransferedCount = this.TransferrableList.length;
          var listDiscarded = this.DiscardedList.filter(
            function (c) {
              return c.isDisCarded == true;

            });
          this.DiscardedList = listDiscarded;
          this.DiscardedCount = this.DiscardedList.length;
          //alert(this.TransferedCount);
          //alert(this.TransferrableList[1].WellNo);
          // alert(this.CurrentSingleWellCultureByCycleCodeController[0].WellNo);
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.LoadOqaData();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentIvfOocyteEmbryoStorageByCodeController: Array<IvfOocyteEmbryoStorageByCodeController>;
  CurrentIvfOocyteEmbryoStorageByCodeRequest: IvfOocyteEmbryoStorageByCodeRequest;

  LoadOqaData() {
    //alert("ScansData")
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest = new IvfOocyteEmbryoStorageByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.ActorCode = this.route.snapshot.paramMap.get('ActorCodedata');
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfOocyteEmbryoStorageByCodeController();
  }

  GetIvfOocyteEmbryoStorageByCodeController() {
    this.StartRefreshing();

    //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.SelectedpatientDetails.EggSourceActorCode;
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.TreatmentCycleCode;
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.ActorCode;
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ConditionalOperator = 20;

    //alert(this.FormattedCode);
    this.actorservice.GetIvfOocyteEmbryoStorageByCodeController(this.CurrentIvfOocyteEmbryoStorageByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfOocyteEmbryoStorageByCodeController = this.ApiResData.Result;

          if (this.CurrentIvfOocyteEmbryoStorageByCodeController != null ||
            this.CurrentIvfOocyteEmbryoStorageByCodeController.length > 0) {

            this.EmbryoStoreItems = new Array<EmbryoStoreItem>();
            this.CurrentIvfOocyteEmbryoStorageByCodeController.forEach((v, i, d) => {
              var item = new EmbryoStoreItem();
              item.IsSelected = false;
              //item.Morphology = v.Morphology;
              item.Grade = v.Grade;
              item.OocyteEmbryoStorageCode = v.OocyteEmbryoStorageCode;
              item.Status = v.Status;
              //item.Morphology = "";
              item.StorageUnitType = v.StorageUnitType;
              item.StorageUnitDetails = v.StorageUnitDetails;
              item.WellNo = v.WellNo;
              this.EmbryoStoreItems.push(item);
            });

          }

          //this.OocyteQADetails = this.CurrentOocyteQualityAssessmentByCodeController[0];
          //this.CurrentOocyteQualityAssessmentByCodeController = new Array<OocyteQualityAssessmentByCodeController>();
          //var data = this.ApiResData.Result as Array<OocyteQualityAssessmentByCodeController>;

          //data.forEach((v, i, a) => {
          //    this.CurrentOocyteQualityAssessmentByCodeController.push(v);
          //});
          //for (let index = 0; index < data.length; index++){
          //    //alert(data[index].SingleWellFollicleCoder);

          //    this.CurrentOocyteQualityAssessmentByCodeController.push(data[index]);
          //}
          //    this.FollicularOocyteInfo = this.CurrentOocyteQualityAssessmentByCodeController[0];
          //   alert(this.FollicularOocyteInfo.TreatmentCycle);
          //if (this.FollicularScanEndInfo.ScanDate != null) {
          //  var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
          //  if (SValidFrom.getFullYear() > 1900) {
          //    console.log('this.UpdateDate >1990');
          //    this.ScanDate = {

          //      year: SValidFrom.getFullYear(),
          //      month: SValidFrom.getMonth() + 1,
          //      day: SValidFrom.getDate()
          //    }
          //  }
          //}
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.LoadPatients();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  EmbryoStoreItems: Array<EmbryoStoreItem>;
  Store() {

    var toFreeze = this.CurrentSingleWellCultureByCycleCodeController.filter(function (v, i, d) {
      return v.IsFrozen == true
    });

    if (this.CurrentIvfOocyteEmbryoStorageByCodeController == null ||
      this.CurrentIvfOocyteEmbryoStorageByCodeController.length == 0) {

      this.EmbryoStoreItems = new Array<EmbryoStoreItem>();
      toFreeze.forEach((v, i, d) => {
        var item = new EmbryoStoreItem();
        item.IsSelected = false;
        item.Grade = this.GetMaxGrade(v);
        item.OocyteEmbryoStorageCode = 0;
        item.WellNo = v.WellNo;
        //item.Morphology = "";
        this.EmbryoStoreItems.push(item);
      });

    }
  }
  CurrentCycleOocyteQualityBetweenDateController: CycleOocyteQualityBetweenDateController[];
  CurrentCycleOocyteQualityBetweenDateRequest: CycleOocyteQualityBetweenDateRequest;
  LoadPatients() {
    this.CurrentCycleOocyteQualityBetweenDateRequest = new CycleOocyteQualityBetweenDateRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentCycleOocyteQualityBetweenDateRequest.FacilityCode = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;
    this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date(2017, 1, 1);// "1-JAN-2017";
    this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();// "31-DEC-2018";
    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentCycleOocyteQualityBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetCycleOocyteQualityBetweenDateController();
  }

  GetCycleOocyteQualityBetweenDateController() {
    this.StartRefreshing();


    this.actorservice.GetCycleOocyteQualityBetweenDateController(this.CurrentCycleOocyteQualityBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCycleOocyteQualityBetweenDateController = this.ApiResData.Result;
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.printService.onDataReady();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {
    //alert("in scans comp");
    this.Date = new Date();

    this.Doc = this.route.snapshot.paramMap.get('Doc');
    this.DocDate = this.route.snapshot.paramMap.get('DocDate');
    this.Owner = this.route.snapshot.paramMap.get('Owner');
    this.FormattedCode = this.route.snapshot.paramMap.get('PatientId');
    this.Protocolst = this.route.snapshot.paramMap.get('ProtocolStart');
    this.ProtocolEd = this.route.snapshot.paramMap.get('ProtocolEnd');
    this.Protocol = this.route.snapshot.paramMap.get('Protocol');
    this.Infertility = this.route.snapshot.paramMap.get('Infertility');
    this.Gender = this.route.snapshot.paramMap.get('Gender');
    this.Age = this.route.snapshot.paramMap.get('Age');
    this.CycleNo = this.route.snapshot.paramMap.get('CycleNo');
    this.CycleType = this.route.snapshot.paramMap.get('CycleType');
    this.TotalOocytes = this.route.snapshot.paramMap.get('TotalOocytes');

    this.LoadSingle();

  }
  GetMaxDOC(l: SingleWellCultureByCycleCodeController): number {
    if (l.DocID1 != null) {
      return l.DOC1
    }
    else if (l.DocID2 != null) {
      return l.DOC2
    }
    else if (l.DocID3 != null) {
      return l.DOC3
    }
    else if (l.DocID4 != null) {
      return l.DOC4
    }
    else if (l.DocID5 != null) {
      return l.DOC5
    }
    else if (l.DocID6 != null) {
      return l.DOC6
    }
    return 0;

  }

  GetMaxGrade(l: SingleWellCultureByCycleCodeController): string {
    if (l.Grade6 != null) {
      return l.Grade6
    }
    else if (l.Grade5 != null) {
      return l.Grade5
    }
    else if (l.Grade4 != null) {
      return l.Grade4
    }
    else if (l.Grade3 != null) {
      return l.Grade3
    }
    else if (l.Grade2 != null) {
      return l.Grade2
    }
    else if (l.Grade1 != null) {
      return l.Grade1
    }
    return "";

  }
  GetMaxImage(l: SingleWellCultureByCycleCodeController): number {
    if (l.Image6 != null) {
      return l.Image6
    }
    else if (l.Image5 != null) {
      return l.Image5
    }
    else if (l.Image4 != null) {
      return l.Image4
    }
    else if (l.Image3 != null) {
      return l.Image3
    }
    else if (l.Image2 != null) {
      return l.Image2
    }
    else if (l.Image1 != null) {
      return l.Image1
    }
    return 0;

  }
  GetMaxImageUrl(l: SingleWellCultureByCycleCodeController): string {
    if (l.DocID6 != null) {
      return l.DocFriendlyName6
    }
    else if (l.DocID5 != null) {
      return l.DocFriendlyName5
    }
    else if (l.DocID4 != null) {
      return l.DocFriendlyName4
    }
    else if (l.DocID3 != null) {
      return l.DocFriendlyName3
    }
    else if (l.DocID2 != null) {
      return l.DocFriendlyName2
    }
    else if (l.DocID1 != null) {
      return l.DocFriendlyName1
    }
    return null;

  }
  //GetImageUrl(l: SingleWellCultureByCycleCodeController, doc: number): string {
  //  //this.IsGradingCompleted


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}








